import React from 'react'
import Navbar from '../../LandingPage/Navbar/Navbar'
import AboutUsPage from '../../AboutUsPage/AboutUsPage'
import Footer2 from '../../Footer2/Footer2'
import TopBar from '../../EdofSectionNew2/TopBar/TopBar'
const AboutUs = () => {
    return (
        <div>
            <TopBar />
            <Navbar />
            <AboutUsPage />
            <Footer2 />

        </div>
    )
}

export default AboutUs
